import mainCaller from "./mainCaller";
import QueryString from 'qs';

export const sendVerification = async (data) => {
  return await mainCaller(`admin/api/v1/auth/send-verification-code`, 'POST', data);
}

export const checkVerification = async (data) => {
  return await mainCaller(`admin/api/v1/auth/check-verification-code`, 'POST', data,);
}

export const findUserName = async (data) => {
  return await mainCaller(`admin/api/v1/auth/find-username`, 'POST', data,);
}

export const forgotPassword = async (data) => {
  return await mainCaller(`admin/api/v1/auth/forgot-password`, 'POST', data,);
}


